// How an officer account is described in the header, as the app describes it
// (packages/mobile/src/utils/account.js): admins by role, everyone else by
// the designation they were invited with.

const ADMIN_ROLE_LABELS = {
  PRIMARY_ADMIN: "Primary admin",
  ADMIN: "Admin",
};

const TYPE_LABELS = {
  INSTITUTION_OFFICER: "Institution officer",
  ORGANISATION_OFFICER: "Organisation officer",
};

/** An officer's role in words; the account type when it has no officer record. */
export function officerRoleLabel(user) {
  const officer = user?.organisationOfficer || user?.institutionOfficer;
  if (officer) {
    return ADMIN_ROLE_LABELS[officer.role] || officer.designation || "Reviewer";
  }
  return TYPE_LABELS[user?.type] || "";
}
